/**
 * 表紙・特集商品選定依頼確認（バイヤー用）画面の媒体クラス
 *
 * @export MediumType
 * @class MediumType
 */
export class MediumType {
  constructor(
    public mediumType: string,
    public mediumName: string,
  ) {}
}
